import React from 'react'
import { useNavigate } from "react-router-dom";
import { PageSubHeader } from 'components/CommonLayouts/PageSubHeader';
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Row,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

const VendorJobs = () => {
  const navigate = useNavigate();
  const jobPostings = [
    {
      id: "JB1023",
      title: "Frontend Developer",
      department: "Engineering",
      experience: "3 Yrs",
      location: "Onsite",
      openings: 3,
      SubmittedProfiles: 3,
      salary: "---",
      postedOn: "23-01-2025",
      expiryDate: "28-01-2025",
      status:"Open",
    },
    {
      id: "JB1027",
      title: "UI UX Designer",
      department: "Design",
      experience: "3 Yrs",
      location: "Remote",
      openings: 2,
      SubmittedProfiles: 2,
      salary: "---",
      postedOn: "21-01-2025",
      expiryDate: "25-01-2025",
      status:"Open",
    },
    {
      id: "JB1020",
      title: "Quality Analyst",
      department: "Testing",
      experience: "5 Yrs",
      location: "Onsite",
      openings: 2,
      SubmittedProfiles: 2,
      salary: "---",
      postedOn: "20-01-2025",
      expiryDate: "22-01-2025",
      status:"Expired",
    },
  ];   

  
  return (
    <div className="py-5 px-4">
  <Row className="mt-3">
    <Col>
      <PageSubHeader
        heading={"View Job Postings"}
        routePath={"Home"}
        pageName={"View Job Postings"}
      />
      <p className="text-muted pt-2">
       Discover Open Roles. Align Candidates. Boost Submissions.
      </p>
    </Col>
   </Row>  
      <Container fluid className="py-0 px-0">
          {/* Filters */}
          <Row>
            <Col className="d-flex gap-3 align-items-center">
              <InputGroup
                size="sm"
                className="elbert-search-group"
                style={{ width: "348px" }}
              >
                <Input
                  placeholder="Search by job title"
                  className="elbert-search"
                />
                <InputGroupText>
                  <span className="fa fa-search"></span>
                </InputGroupText>
              </InputGroup>

              <Input
                type="select"
                className="elbert-search"
                style={{ width: "178px" }}
              >
                <option value="">Department</option>
                <option value="engineering">Engineering</option>
                <option value="marketing">Marketing</option>
              </Input>

              <Input
                type="select"
                className="elbert-search"
                style={{ width: "125px", marginLeft: "16px" }}
              >
                <option value="">Location</option>
                <option value="newyork">New York</option>
                <option value="sf">San Francisco</option>
              </Input>

              <Input
                type="select"
                className="elbert-search"
                style={{ width: "125px", marginLeft: "16px" }}
              >
                <option value="">Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </Input>
            </Col>
          </Row>

          {/* Job Postings Table */}
          <Row className="mt-4 mx-0">
            <Card>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table mb-0 border: 0.4px solid #D4D4D4;">
                    <thead>
                      <tr>
                        <th>Job ID</th>
                        <th>Job Title</th>
                        <th>Department</th>
                        <th>Experience</th>
                        <th>Location</th>
                        <th>Openings</th>
                        <th>Submitted Profiles</th>
                        <th>Salary</th>
                        <th>Posted On</th>
                        <th>Expiry Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobPostings.map((job) => (
                        <tr key={job.id}>
                          <td>{job.id}</td>
                          <td>{job.title}</td>
                          <td>{job.department}</td>
                          <td>{job.experience}</td>
                          <td>{job.location}</td>
                          <td>{job.openings}</td>
                          <td>{job.SubmittedProfiles}</td>
                          <td>{job.salary}</td>
                          <td>{job.postedOn}</td>
                          <td>{job.expiryDate}</td>
                          <td >{job.status === "Open"? "Open":"Expired"}</td>
                          <td>
                            <div className="d-flex gap-2">
                              <i
                                className="fa-solid fa-eye action-icon"
                                title="View"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigate(`/view-job/${job.id}`)}
                              ></i>
                              <i
                              className="fa-solid fa-download action-icon ps-2"
                              title="Download"
                              style={{ cursor: "pointer" }}
                              ></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Row>
      </Container>
    </div>   
  )
}

export default VendorJobs